import * as React from 'react';
import JobStatusEvent from "../../../../model/job/event/JobStatusEvent";
import CommonStreamItem, {StreamItemAction} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import {downloadWarrantyCsv} from "../../../../store/action/job/job";
import {getJobByIdOrRefNumber} from "../../../../store/view/job";
import {store} from "../../../../navigation/ReduxProvider";

interface Props {
	/**
	 * Job activity to display.
	 */
	activity: JobStatusEvent
}

export default class JobActivityStatusChangedWithAction extends React.PureComponent<Props> {

	render() {
		let actions: StreamItemAction[] = [];
		const installationCompleteStatusId = "bcc060ac-a534-4bbf-9470-fbeb518eab6b";
		const isJobWithQuote = getJobByIdOrRefNumber(this.props.activity.jobId, store.getState()).map(
			j => j.quoteId.isDefined).getOrElse(false);
		if (this.props.activity.data.currentStatusId == installationCompleteStatusId && isJobWithQuote) {
			actions.push(StreamItemAction.new("Warranty csv download", this.downloadWarranty));
		}
		return <CommonStreamItem event={this.props.activity} actions={actions}/>
	}

	downloadWarranty = () => downloadWarrantyCsv(this.props.activity.jobId);
}

